import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * ParallaxBg — animates a background image vertically as the section
 * scrolls through the viewport. Designed to sit inside a relatively
 * positioned parent and act as the section background layer.
 *
 * The image is intentionally oversized (top:-15%, bottom:-15%) so it
 * has room to translate without revealing the underlying section bg.
 */
export default function ParallaxBg({
  src,
  speed = 0.18,
  className = "",
  position = "center center",
  size = "cover",
  flipX = false,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  // Translate range proportional to speed (default 18% of section height)
  const y = useTransform(
    scrollYProgress,
    [0, 1],
    [`${-speed * 100}%`, `${speed * 100}%`]
  );

  return (
    <div
      ref={ref}
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
    >
      <motion.div
        className="absolute -inset-y-[20%] inset-x-0"
        style={{
          y,
          backgroundImage: `url(${src})`,
          backgroundSize: size,
          backgroundPosition: position,
          backgroundRepeat: "no-repeat",
          scaleX: flipX ? -1 : 1,
        }}
      />
    </div>
  );
}
